// extracted by mini-css-extract-plugin
module.exports = {"metersList":"RoomDdy_metersList__1rhPQ","content":"RoomDdy_content__2rACF","wrapperLife":"RoomDdy_wrapperLife__1_irz"};